export default __webpack_public_path__ + "static/media/house1.2626cd85.png";